import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';

const discFactorLabels = {
    D: 'Dominância',
    I: 'Influência',
    S: 'Estabilidade',
    C: 'Conformidade',
};

const isDisc = (value) => value == true || value == 1;
const getDiscFactor = (alternativa) => alternativa?.disc_factor ?? alternativa?.factor ?? alternativa?.alternativa_factor ?? '';

const normalizeDiscAnswer = (resposta) => {
    if (resposta == null || typeof resposta !== 'object') return {};

    return {
        mais: resposta.mais ?? resposta.more ?? resposta[1]?.alternativa ?? resposta[1]?.letter,
        menos: resposta.menos ?? resposta.less ?? resposta[2]?.alternativa ?? resposta[2]?.letter,
        mais_factor: resposta.mais_factor ?? resposta.more_factor ?? resposta[1]?.factor,
        menos_factor: resposta.menos_factor ?? resposta.less_factor ?? resposta[2]?.factor,
    };
};

const normalizeFlatDiscAnswer = (resposta) => {
    if (resposta == null || typeof resposta !== 'object') return resposta;

    return resposta.alternativa ?? resposta.letter ?? resposta.resposta ?? resposta.value ?? resposta.name;
};

const getDiscAnswer = (respostas, questaoId) => {
    const nestedAnswer = normalizeDiscAnswer(respostas?.[questaoId]);
    if (nestedAnswer.mais || nestedAnswer.menos) return nestedAnswer;

    return {
        mais: normalizeFlatDiscAnswer(respostas?.[`${questaoId}-1`]),
        menos: normalizeFlatDiscAnswer(respostas?.[`${questaoId}-2`]),
        mais_factor: respostas?.[`${questaoId}-1`]?.factor,
        menos_factor: respostas?.[`${questaoId}-2`]?.factor,
    };
};

const parseRespostas = (respostas) => {
    if (!respostas) return {};
    if (typeof respostas === 'object') return respostas;

    try {
        return JSON.parse(respostas);
    } catch (e) {
        return {};
    }
};

const DecideDiscBorder = (resposta, atual) => {
    const discAnswer = normalizeDiscAnswer(resposta);
    if (discAnswer.mais == atual) return '1px solid #198754';
    if (discAnswer.menos == atual) return '1px solid #dc3545';
    return '';
};

const DiscChoiceInfo = ({ resposta, atual }) => {
    const discAnswer = normalizeDiscAnswer(resposta);
    if (discAnswer.mais == atual) {
        return <p style={{ color: '#198754', marginBottom: 0 }}><b>Mais se identifica</b></p>;
    }
    if (discAnswer.menos == atual) {
        return <p style={{ color: '#dc3545', marginBottom: 0 }}><b>Menos se identifica</b></p>;
    }
    return null;
};

const DiscFactorInfo = ({ alternativa }) => {
    const factor = getDiscFactor(alternativa);
    if (!factor) return null;

    return (
        <p style={{ color: 'black', marginTop: 4, marginBottom: 0 }}>
            <b>{factor}</b> — {discFactorLabels[factor] ?? factor}
        </p>
    );
};

const ModalRespostas = props => {
    const { provaSelect,model, showModal, setShowModal, questoes, prova_name } = props;
    const isDiscProva = isDisc(props.is_disc);
    console.log(provaSelect)
    let respostas = provaSelect != null ? parseRespostas(provaSelect.respostas) : {};
    const getRespostaQuestao = (questaoId) => isDiscProva ? getDiscAnswer(respostas, questaoId) : respostas[questaoId];

    const DecideBorder = (resposta, correta, atual) => {
        if (atual == resposta && resposta == correta) {
            return '1px solid green';
        }
        else if (atual == resposta) {
            return '1px solid red';
        }
        else if (atual == correta) {
            return '1px solid green';
        }
        else {
            return '';
        }
    }
    console.log(questoes)
    let number_questao = 0;
    return (
        provaSelect != null && <Modal
            show={showModal == true}
            dialogClassName="modal_width"
            onHide={() => setShowModal(false)}
        >
            <Modal.Header closeButton closeLabel=''><Modal.Title>{!model ? <>Respostas {provaSelect.user.name} - {prova_name}</>: <>{prova_name}</>}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                <div className="custom_scrollbar">

                    {questoes!=null && questoes.map((item, id) => {
                        if (item.type_questao == 'simples' || item.type_questao == 'dissertativa') {
                            number_questao = number_questao + 1;
                        }
                        return (
                            <div key={id}>
                                <hr />

                                <h6 className="mt-0 header-title" style={{ textAlign: 'right', marginBottom: 10, fontSize: 15 }}>
                                    {item.categoria.name}</h6>

                                {item.type_questao == 'dissertativa' && <div className="row" style={{ fontWeight: 'normal',margin:0,margin:0 }}>
                                {item.status=='A' && <div className="col-12">
                                        <div style={{backgroundColor:'white',border:'1px solid red',borderRadius:10,color:'red',padding:3,width:'fit-content',marginBottom:10}}>Questão Anulada</div>
                                        </div>}
                                    <div className="col-2 col-sm-1">
                                        <h5 style={{ textAlign: 'justify', color: 'black', marginTop: 0 }}>
                                            <b>{number_questao})</b></h5>
                                    </div>
                                    <div className="col-10 col-sm-11">


                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.name }}>

                                        </div>
                                        {!model && <>
                                        <p><b>Resposta: </b></p>
                                        <p style={{whiteSpace:'pre-line',marginBottom:0}}>
                                            {respostas[item.id] != undefined ? respostas[item.id] : '-'}
                                        </p>
                                        </>}
                                        
                                    </div>
                                </div>}
                                {/* {!!Form::open(['action' =>
['ProcessoUserController@responder_questao'],'data-toggle'=>'validator','files' =>
false,'method'=>'post','id'=>$data['prova']->id.'_'.$questao->id]) !!} */}
                                {item.type_questao == 'simples' && <div className="row" style={{ fontWeight: 'normal',margin:0 }}>
                                {item.status=='A' && <div className="col-12">
                                        <div style={{backgroundColor:'white',border:'1px solid red',borderRadius:10,color:'red',padding:3,width:'fit-content',marginBottom:10}}>Questão Anulada</div>
                                        </div>}

                                    
                                    <div className="col-2 col-sm-1">
                                        <h5 style={{ textAlign: 'justify', color: 'black', marginTop: 0 }}>
                                            <b>{number_questao})</b></h5>
                                    </div>
                                    <div className="col-10 col-sm-11">


                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.name }}>

                                        </div>
                                        <p><b>Alternativas:</b></p>
                                        {!isDiscProva && <p><b>Correta: </b>{item.correta}</p>}
                                        {!model && !isDiscProva && <>
                                        <p><b>Respondida: </b>{respostas[item.id] != undefined ? respostas[item.id] : '-'}</p>
                                        </>}

                                        <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item.id), 'a') : DecideBorder(respostas[item.id] != undefined ? respostas[item.id] : '-', item.correta, 'a') }}>
                                            <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                <p style={{ color: 'black', fontWeight: 'normal' }}>a)</p>
                                            </div>
                                            <div style={{ width: '90%' }}>

                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[0].name }}>

                                                </div>
                                                {isDiscProva && <DiscFactorInfo alternativa={item.alternativas[0]} />}
                                                {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item.id)} atual="a" />}
                                            </div>

                                        </div>
                                        {item.alternativas[1] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item.id), 'b') : DecideBorder(respostas[item.id] != undefined ? respostas[item.id] : '-', item.correta, 'b') }}>
                                            <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                <p style={{ color: 'black', fontWeight: 'normal' }}>b)</p>
                                            </div>
                                            <div style={{ width: '90%' }}>

                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[1].name }}>

                                                </div>
                                                {isDiscProva && <DiscFactorInfo alternativa={item.alternativas[1]} />}
                                                {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item.id)} atual="b" />}
                                            </div>

                                        </div>}
                                        {item.alternativas[2] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item.id), 'c') : DecideBorder(respostas[item.id] != undefined ? respostas[item.id] : '-', item.correta, 'c') }}>
                                            <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                <p style={{ color: 'black', fontWeight: 'normal' }}>c)</p>
                                            </div>
                                            <div style={{ width: '90%' }}>

                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[2].name }}>

                                                </div>
                                                {isDiscProva && <DiscFactorInfo alternativa={item.alternativas[2]} />}
                                                {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item.id)} atual="c" />}
                                            </div>

                                        </div>}
                                        {item.alternativas[3] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item.id), 'd') : DecideBorder(respostas[item.id] != undefined ? respostas[item.id] : '-', item.correta, 'd') }}>
                                            <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                <p style={{ color: 'black', fontWeight: 'normal' }}>d)</p>
                                            </div>
                                            <div style={{ width: '90%' }}>

                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[3].name }}>

                                                </div>
                                                {isDiscProva && <DiscFactorInfo alternativa={item.alternativas[3]} />}
                                                {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item.id)} atual="d" />}
                                            </div>

                                        </div>}

                                        {item.alternativas[4] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item.id), 'e') : DecideBorder(respostas[item.id] != undefined ? respostas[item.id] : '-', item.correta, 'e') }}>
                                            <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                <p style={{ color: 'black', fontWeight: 'normal' }}>e)</p>
                                            </div>
                                            <div style={{ width: '90%' }}>

                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[4].name }}>

                                                </div>
                                                {isDiscProva && <DiscFactorInfo alternativa={item.alternativas[4]} />}
                                                {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item.id)} atual="e" />}
                                            </div>

                                        </div>}
                                    </div>
                                </div>}





                                {item.type_questao == 'conjunto' && <div className="row" style={{ fontWeight: 'normal',margin:0 }}>
                                {item.status=='A' && <div className="col-12">
                                        <div style={{backgroundColor:'white',border:'1px solid red',borderRadius:10,color:'red',padding:3,width:'fit-content',marginBottom:10}}>Questão Anulada</div>
                                        </div>}
                                    <div className="col-12 col-sm-12">


                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.name }}>

                                        </div>
                                        {item.questoes.map((item2, id2) => {
                                            number_questao = number_questao + 1;

                                            return (<div key={id2} className="row" style={{ fontWeight: 'normal',margin:0 }}>
                                                <div className="col-2 col-sm-1">
                                                    <h5 style={{ textAlign: 'justify', color: 'black', marginTop: 0 }}>
                                                        <b>{number_questao})</b></h5>
                                                </div>
                                                <div className="col-10 col-sm-11">


                                                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.name }}>

                                                    </div>
                                                    <p><b>Alternativas:</b></p>
                                                    {!isDiscProva && <p><b>Correta: </b>{item2.correta}</p>}
                                                    {!model && !isDiscProva && <>
                                                    <p><b>Respondida: </b>{respostas[item2.id] != undefined ? respostas[item2.id] : '-'}</p>
                                                    </>}

                                                    <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item2.id), 'a') : DecideBorder(respostas[item2.id] != undefined ? respostas[item2.id] : '-', item2.correta, 'a') }}>
                                                        <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                            <p style={{ color: 'black', fontWeight: 'normal' }}>a)</p>
                                                        </div>
                                                        <div style={{ width: '90%' }}>

                                                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[0].name }}>

                                                            </div>
                                                            {isDiscProva && <DiscFactorInfo alternativa={item2.alternativas[0]} />}
                                                            {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item2.id)} atual="a" />}
                                                        </div>

                                                    </div>
                                                    {item2.alternativas[1] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item2.id), 'b') : DecideBorder(respostas[item2.id] != undefined ? respostas[item2.id] : '-', item2.correta, 'b') }}>
                                                        <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                            <p style={{ color: 'black', fontWeight: 'normal' }}>b)</p>
                                                        </div>
                                                        <div style={{ width: '90%' }}>

                                                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[1].name }}>

                                                            </div>
                                                            {isDiscProva && <DiscFactorInfo alternativa={item2.alternativas[1]} />}
                                                            {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item2.id)} atual="b" />}
                                                        </div>

                                                    </div>}
                                                    {item2.alternativas[2] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item2.id), 'c') : DecideBorder(respostas[item2.id] != undefined ? respostas[item2.id] : '-', item2.correta, 'c') }}>
                                                        <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                            <p style={{ color: 'black', fontWeight: 'normal' }}>c)</p>
                                                        </div>
                                                        <div style={{ width: '90%' }}>

                                                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[2].name }}>

                                                            </div>
                                                            {isDiscProva && <DiscFactorInfo alternativa={item2.alternativas[2]} />}
                                                            {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item2.id)} atual="c" />}
                                                        </div>

                                                    </div>}
                                                    {item2.alternativas[3] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item2.id), 'd') : DecideBorder(respostas[item2.id] != undefined ? respostas[item2.id] : '-', item2.correta, 'd') }}>
                                                        <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                            <p style={{ color: 'black', fontWeight: 'normal' }}>d)</p>
                                                        </div>
                                                        <div style={{ width: '90%' }}>

                                                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[3].name }}>

                                                            </div>
                                                            {isDiscProva && <DiscFactorInfo alternativa={item2.alternativas[3]} />}
                                                            {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item2.id)} atual="d" />}
                                                        </div>

                                                    </div>}

                                                    {item2.alternativas[4] != undefined && <div style={{ display: 'flex', marginTop: 10, border: isDiscProva ? DecideDiscBorder(getRespostaQuestao(item2.id), 'e') : DecideBorder(respostas[item2.id] != undefined ? respostas[item2.id] : '-', item2.correta, 'e') }}>
                                                        <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                            <p style={{ color: 'black', fontWeight: 'normal' }}>e)</p>
                                                        </div>
                                                        <div style={{ width: '90%' }}>

                                                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[4].name }}>

                                                            </div>
                                                            {isDiscProva && <DiscFactorInfo alternativa={item2.alternativas[4]} />}
                                                            {isDiscProva && !model && <DiscChoiceInfo resposta={getRespostaQuestao(item2.id)} atual="e" />}
                                                        </div>

                                                    </div>}
                                                </div>
                                            </div>)
                                        })}

                                    </div>
                                </div>}
                            </div>

                        )
                    })}


                </div>


            </Modal.Body>
        </Modal>

    );
}

export default ModalRespostas;
